import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { TrendingUp, ArrowUp } from "lucide-react";
import { api } from "@/lib/api";
import { useSiteConfig } from "@/context/SiteConfigContext";

export default function Leaderboard() {
  const { config } = useSiteConfig();
  const t = config.t.leaderboard;
  const [cities, setCities] = useState([]);
  useEffect(() => {
    api.get("/cities/leaderboard?limit=8").then((r) => setCities(r.data)).catch(() => {});
  }, []);

  if (!cities.length) return null;
  const max = Math.max(...cities.map((c) => c.count), 1);

  return (
    <section id="launch-cities" className="bg-white py-28 sm:py-36" data-testid="leaderboard-section">
      <div className="mx-auto max-w-4xl px-6">
        <Reveal className="text-center">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-brand">{t.eyebrow}</p>
          <h2 className="mx-auto mt-4 max-w-2xl text-4xl font-bold tracking-tighter text-neutral-900 sm:text-5xl lg:text-6xl">
            {t.heading}
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-lg text-neutral-500">
            {t.paragraph}
          </p>
        </Reveal>

        <div className="mt-14 space-y-3">
          {cities.map((c, i) => (
            <motion.div key={c.label}
              initial={{ opacity: 0, x: -16 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}
              transition={{ delay: i * 0.05, duration: 0.5 }}
              className="relative overflow-hidden rounded-2xl border border-black/5 bg-[#FAFAFC] p-5"
              data-testid={`leaderboard-row-${i}`}>
              <div className="relative z-10 flex items-center gap-4">
                <span className={`grid h-9 w-9 shrink-0 place-items-center rounded-full text-sm font-bold ${i === 0 ? "bg-brand text-white" : "bg-white text-neutral-500 ring-1 ring-black/5"}`}>{i + 1}</span>
                <div className="flex-1">
                  <p className="text-[15px] font-bold text-neutral-900">{c.label}</p>
                  <div className="mt-2 h-1.5 w-full max-w-xs overflow-hidden rounded-full bg-black/5">
                    <motion.div className="h-full rounded-full bg-brand" initial={{ width: 0 }} whileInView={{ width: `${(c.count / max) * 100}%` }} viewport={{ once: true }} transition={{ delay: 0.2 + i * 0.05, duration: 0.8 }} />
                  </div>
                </div>
                <div className="text-right">
                  <p className="flex items-center gap-1 text-lg font-bold text-neutral-900"><TrendingUp className="h-4 w-4 text-ai" />{c.count}</p>
                  <p className="text-[11px] font-medium text-neutral-400">waiting</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a href="#launch-location" className="inline-flex items-center gap-2 rounded-full bg-brand px-7 py-3.5 text-base font-semibold text-white transition-transform hover:bg-brand-dark active:scale-95" data-testid="move-city-up-btn">
            <ArrowUp className="h-4 w-4" /> {t.cta}
          </a>
          <p className="mt-4 text-sm text-neutral-400">{t.note}</p>
        </div>
      </div>
    </section>
  );
}
